import { useEffect } from 'react';
import { useState } from 'react';
import './App.scss';
import ArticleQuiz from './components/articleTemplate/ArticleQuiz';
import "./components/articleTemplate/ArticleWeekQuiz.scss";
import './pages/page.css'

function AppArticle() {
  const [start, setStart] = useState(false);


  useEffect(() => {

    const onPageLoad = () => {
      setStart(true);
    };

    if (document.readyState === "complete") {
      onPageLoad();
    } else {
      window.addEventListener("load", onPageLoad);
      return () => window.removeEventListener("load", onPageLoad);
    }
  }, []);

  return (
    <div className="App" aria-live="polite" >
      {start && <ArticleQuiz />}
    </div>
  );
}

export default AppArticle;
